import AddTenant from '../../../components/add-tenant';

const NewTenantPage = () => <AddTenant />;

export default NewTenantPage;
